import React, { Component } from "react";
import { renderInterestTracks } from './fpgViewHelpers';
import { Link } from "react-router-dom";
import TwitterIcon from "./../../../icons/twittericon";
import InstaIcon from "./../../../icons/instaicon";
import FpgeeditIcon from "./../../../icons/fpgediticon";
import FpgDisableIcon from "./../../../icons/fpgdisableicon";
import FpgpublishIcon from "./../../../icons/fpgpublishicon";
import FpgDeleteIcon from "./../../../icons/fpgdeleteicon";
import ShowPassIcon from "../../../icons/ShowPassIcon";
import ViewIcon from "../../../icons/viewIcon";
import Slider from "react-slick";
//moment import
import moment from "moment";
//Service import
import service from "../../../services";
import ErrorPopUp from '../../errorPopUp';
import RecordPresenceBanner from "../../RecordPresenceBanner";

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../../redux/bindActionCretor'
import PopUpCustomAll from "../create/popUpCustomAll";
//Validation import
import SimpleReactValidator from 'simple-react-validator';
import Loader from "../../loader";
import { getData, getName } from "../../../functions";
import { resolveFromInitial } from '../../../cosntants';

let sub;

const getEmbedUrl = (url) => {
    if (!url) return '';
    if (url.includes('youtube.com/embed/') || url.includes('player.vimeo.com/video/')) return url;
    const ytMatch = url.match(/(?:youtube\.com\/watch\?[^#]*v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    return url;
};

const mapStateToProps = state => ({
  filmEditId: state.filmEditId,
  profileName: state.profileName,
  recordViewers: state.recordViewers,
  recordConflict: state.recordConflict,
  getLoginAdminByID: state.getLoginAdminByID,
  allInitial: state.allInitial
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};


class FpgFilmDetailView extends Component {
  constructor() {
    super();
    this.state = {
      screening: '',
      errorPopup: false,
      getAlldataFilm: [],
      loaderFlag: false,
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      hideFromLiveFilm: false,
      showFromLiveFilm: false,
      screencontent: false,
      artist: [],
      teamConnectionFirstName: '',
      teamConnectionFirstEmail: '',
      teamConnectionSecondName: '',
      teamConnectionSecondEmail: '',
      holdSceeringAvailableOpted: '',
      waitList_show:false,
      onlineScreeningShow : false,
      shortFilms: [],
      shortIntroduction: '',
      film: {}

    };
    this.apiserve = new service();
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this._hasLeftPresence = false;
  }

  componentDidMount() {
    this.props.ClearRecordPresence();
    {
      if (this.props.allInitial) {
        this.setInitialDataFromProps(this.props.allInitial);
      }
      this.props.filmEditId &&
        this.getAlldetails();
      this.getdetails();
    }

    this.setState({
      loaderFlag: true,
    });

    // RecordPresence: Join if recordId exists
    if (this.props.filmEditId) {
      this.apiserve.sendevent("RecordPresence|join", {
        modelName: "film",
        recordId: this.props.filmEditId
      });
      // Add beforeunload handler
      this._handleBeforeUnload = () => {
        if (!this._hasLeftPresence) {
          this._hasLeftPresence = true;
          this.apiserve.sendevent("RecordPresence|leave", {
            modelName: "film",
            recordId: this.props.filmEditId
          });
        }
      };
      window.addEventListener('beforeunload', this._handleBeforeUnload);
    }
  }

  componentWillUnmount = () => {
    sub.unsubscribe();
    if (this.props.filmEditId && !this._hasLeftPresence) {
      this._hasLeftPresence = true;
      this.apiserve.sendevent("RecordPresence|leave", {
        modelName: "film",
        recordId: this.props.filmEditId
      });
    }
    if (this._handleBeforeUnload) {
      window.removeEventListener('beforeunload', this._handleBeforeUnload);
    }
    this.props.ClearRecordPresence();
  }

  closeAdminUser = () => {
    this.setState({
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
      hideFromLiveFilm: false,
      showFromLiveFilm: false
    })
  }

  getdetails = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "film|getAllDetail":
          if (!response.error) {
            const { allInitial } = this.props;
            const data = response.data;

            // Resolve root-level fields (bare IDs → populated objects)
            data.access        = resolveFromInitial(allInitial, 'film', 'access',        data.access);
            data.category      = resolveFromInitial(allInitial, 'film', 'category',      data.category);
            data.accessibility = resolveFromInitial(allInitial, 'film', 'accessibility', data.accessibility);
            data.awardCategory = resolveFromInitial(allInitial, 'film', 'awardCategory', data.awardCategory);
            data.genre         = resolveFromInitial(allInitial, 'film', 'genre',         data.genre);
            data.interestTrack = resolveFromInitial(allInitial, 'film', 'interestTrack', data.interestTrack);
            data.locations     = resolveFromInitial(allInitial, 'film', 'locations',     data.locations);

            // Resolve dateTime nested fields
            data.dateTime = (data.dateTime || []).map(dt => ({
              ...dt,
              locationCity:  resolveFromInitial(allInitial, 'film', 'city',  dt.locationCity),
              accessibility: resolveFromInitial(allInitial, 'film', 'accessibility', dt.accessibility, 'eventiveId'),
              interestTrack: resolveFromInitial(allInitial, 'film', 'interestTrack', dt.interestTrack || [], 'eventiveId'),
            }));

            this.setState(
              {
                access: data.access ? data.access.name : '',
                eventiveId:response.data.eventiveId,
                getAlldataFilm: response.data,
                mediaId: response.data.mediaId,
                fileMakerId: response.data.fileMakerId,
                images: response.data.images,
                contact: response.data.contact,
                credits: response.data.credits,
                artist: response.data.artist,
                article: response.data.article,
                year: response.data.year,
                category: data.category ? data.category.name : '',
                country: response.data.country,
                language: response.data.language,
                runTime: response.data.runTime,
                company: response.data.company,
                website: response.data.website,
                accessibility: data.accessibility || [],
                description: response.data.description,
                shortDescription: response.data.shortDescription,
                genre: data.genre,
                interestTrack: data.interestTrack,
                dateTime: data.dateTime,
                title: response.data.title,
                hideFromLive: response.data.hideFromLive,
                status: response.data.status,
                categoryname: data.category ? data.category.name : '',
                categorytype: data.category ? data.category.type : '',
                qaReplayLink: response.data.qaReplayLink,
                shortProgramme: response.data.shortProgramme,
                awardCategory: data.awardCategory ? data.awardCategory.name : '',
                awardSponsorLogo: response.data.awardSponsorLogo,
                isExplicitContent: response.data.isExplicitContent,
                explicitContent: response.data.explicitContent,
                sponsorLogo: response.data.sponsorLogo,
                screeningMoreInfoTitle: response.data.screeningMoreInfoTitle,
                screeningMoreInfo: response.data.screeningMoreInfo,
                teamConnectionFirstName: response.data.teamConnection[0] && response.data.teamConnection[0].name ? response.data.teamConnection[0].name : '',
                teamConnectionFirstEmail: response.data.teamConnection[0] && response.data.teamConnection[0].email ? response.data.teamConnection[0].email : '',
                teamConnectionSecondName: response.data.teamConnection[1] && response.data.teamConnection[1].name ? response.data.teamConnection[1].name : '',
                teamConnectionSecondEmail: response.data.teamConnection[1] && response.data.teamConnection[1].email ? response.data.teamConnection[1].email : '',
                lastUpdatedBy: response.data.screening && response.data.screening && response.data.screening.lastUpdatedBy,
                lastUpdatedAt: response.data.screening && response.data.screening && response.data.screening.lastUpdatedAt,
                publicContact:response.data.publicContact,
                postFestivalContact:response.data.postFestivalContact,
                shortIntroduction: response?.data?.shortIntroduction ?? "",
                shortFilms: response?.data?.shortFilms ?? [],
              },
              () => {
                this.setState({
                  loaderFlag: false,
                });
                this.props.setLastUpdated({
                  updatedAt: response?.data?.updatedAt,
                  updatedBy: {
                    fname: response?.data?.updatedBy?.fname,
                    lname: response?.data?.updatedBy?.lname
                  }
                })
              }
            );
          } else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "film|remove":
          if (!response.error) {
            this.props.history.push('/filmlist')
          } else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "film|updateStatus":
          if (!response.error) {
            this.setState({
              hideFromLiveFilm: false,
              disableFilm: false,
              publishFilm: false,
              showFromLiveFilm: false,
            })
            this.apiserve.success('Updated successfully')
            this.apiserve.sendevent("film|getAllDetail", { filmId: this.props.filmEditId });
          }
          else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "fpg|screening|update":
          if (!response.error) {
            this.getAlldetails();
            this.setState({
              loaderFlag: false
            })
          }
          else {
            this.setState({
              loaderFlag: false
            })
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "RecordPresence|viewersUpdate": {
          if (!response.error && response?.data?.recordId === this.props.filmEditId) {
            const currentUserId = this.props.getLoginAdminByID;
            const viewers = response?.data?.viewers || [];
            const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
            const currentUserHasMultipleSessions = currentUserSessionCount > 1;
            const seenIds = new Set();
            const filteredViewers = viewers
              .filter(v => {
                if (v?.userId === currentUserId) {
                  return currentUserHasMultipleSessions;
                }
                return true;
              })
              .filter(v => {
                if (seenIds.has(v?.userId)) return false;
                seenIds.add(v?.userId);
                return true;
              })
              .map(v => ({
                userId: v?.userId,
                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
              }));
            this.props.SetRecordViewers(filteredViewers);
          }
          break;
        }
      }
    });
    this.setState({})
  };



  componentDidUpdate(prevProps) {
    if (prevProps.allInitial !== this.props.allInitial) {
      this.setInitialDataFromProps(this.props.allInitial);
    }
  }

  setInitialDataFromProps = (allInitial) => {
    if (allInitial && allInitial.film) {
      this.setState({
        film: allInitial.film
      });
    }
  }

  getAlldetails = () => {
    var data = { filmId: this.props.filmEditId };
    this.apiserve.sendevent("film|getAllDetail", data);
  };

  getDisplayValue = (accNo) => {
    const { profileName } = this.props;
    let accessValue = profileName.CMA.find(_ => _.access === accNo);
    return accessValue ? accessValue.value : false;
  }

  handelTwitter = (item) => {
    this.state.artist.forEach(element => {
      if (element._id === item._id) {
        window.open(item.twitter, "_blank");
      }
    });

  };

  handelInstagram = (item) => {
    this.state.artist.forEach(element => {
      if (element._id === item._id) {
        window.open(item.instagram, "_blank");
      }
    });

  };

  deleteFilm = () => {
    this.setState({
      deleteFilm: true
    })
  }

  deleteFilmPopupYes = () => {
    this.apiserve.sendevent("film|remove", {
      filmId: this.props.filmEditId
    });
  }

  hideFromLiveFilm = () => {
    this.setState({
      hideFromLiveFilm: true
    })
  }

  hideFromLiveFilmPopupYes = () => {
    this.apiserve.sendevent("film|updateStatus", {
      filmId: this.props.filmEditId,
      status:this.state.status,
      hideFromLive: true
    });
  }

  showFromLiveFilm = () => {
    this.setState({
      showFromLiveFilm: true
    })
  }

  showFromLiveFilmPopupYes = () => {
    this.apiserve.sendevent("film|updateStatus", {
      filmId: this.props.filmEditId,
      status:this.state.status,
      hideFromLive: false
    });
  }
  publishFilm = () => {
    this.setState({
      publishFilm: true
    })
  }

  publishFilmPopupYes = () => {
    this.apiserve.sendevent("film|updateStatus", {
      filmId: this.props.filmEditId,
      hideFromLive:this.state.hideFromLive,
      status: 1
    });
  }

  disableFilm = () => {
    this.setState({
      disableFilm: true
    })
  }

  disableFilmPopupYes = () => {
    this.apiserve.sendevent("film|updateStatus", {
      filmId: this.props.filmEditId,
      hideFromLive:this.state.hideFromLive,
      status: 2
    });
  }

  editFilmEvent = () => {
    this.props.CurrentTab(0)
    this.props.history.push({
      pathname: `/create-film/${this.props.filmEditId}/edit`,
      callFrom: 0
    });
  };

  ScreenToggle = (e) => {
    var active = e.target.parentNode.closest(".inner_screen").querySelector(".screen_header").classList.toggle("active");
    var parentactive = e.target.closest(".screen_header").parentNode.parentNode.classList.toggle("active");
    var panel = e.target.parentNode.closest(".inner_screen").querySelector(".screen_content_outer");
    if (panel && panel.style.maxHeight) {
      panel.style.maxHeight = "";
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
    this.setState({
      screencontent: !this.state.screencontent
    })
  }

  errorMsgPopup = () => {
    this.setState({
      errorPopup: false
    })
  }

  refreshScreening = (e) => {
    this.setState({
      loaderFlag: true
    })
    var data = { filmId: this.props.filmEditId };
    this.apiserve.sendevent("film|getAllDetail", data);
  }
  getScreeningName = (item) => {
    if(this.state.film !== undefined) {
      let screeningName = this.state.film.screnningTypeList && this.state.film.screnningTypeList.find(_ => _.type === item.screeningType && item?.locationType == _.locationType);
      return screeningName ? screeningName.name : 'N/A';
    }
  }

  render() {
    var settings = {
      customPaging: function (i) {
        return <a>{i + 1}</a>;
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    const {profileName, recordViewers, getLoginAdminByID} = this.props
    var userRole = localStorage.getItem('currentUserRole')
    let shortProgramme = new Date(this.state.shortProgramme && this.state.shortProgramme.date)

    const activeViewers = recordViewers || [];

    const { total, online, awardWinneraAllowed, awardWinneraOpted, awardWinneraConsumed, catchUpAccessAllowed, catchUpAccessConsumed, catchUpTicketsOpted,
      catchUpTicketsAllowed, catchUpAccessOpted, catchUpTicketsConsumed, industryReservationAllowed, industryReservationOpted, industryReservationConsumed,
      premierTicketsAllowed, premierTicketsOpted, premierTicketsConsumed, premierTicketsWaitList, publicPassHolderAllowed, publicPassHolderOpted, publicPassHolderConsumed, lastUpdatedBy, lastUpdatedAt, holdSceeringAvailableOpted, online_held, total_held,onlineAllocation_consumed,onlineAllocation_allowed,inPersonAllocation_allowed,inPersonAllocation_consumed } = this.state
    let premierTicketsAllowedCal = premierTicketsAllowed - premierTicketsOpted
    let publicPassHolderAllowedCal = publicPassHolderAllowed - publicPassHolderOpted
    let industryReservationAllowedCal = industryReservationAllowed - industryReservationOpted
    let remainderSceeringAvailableOpted = premierTicketsAllowedCal + publicPassHolderAllowedCal + industryReservationAllowedCal
    let remainderSceeringAvailableConsumed = premierTicketsConsumed + publicPassHolderConsumed + industryReservationConsumed
    return (
      <>
        <RecordPresenceBanner activeViewers={activeViewers} conflict={null} />
        <div className="fpg_tabcontent d_flex">
        <>
        <div className="tab_col left_col">
          <div className="d_flex id_media d_flex_align_center">
            { <span className="id_text">
              <label>Eventive  ID:</label> {this.state.eventiveId}
            </span>}
            <span className="id_text">
              <label>Media ID:</label> {this.state.mediaId}
            </span>
          </div>
          <Slider {...settings}>
            {this.state.images &&
              this.state.images.map((item) => (
                <div>
                  <div className="media_image">
                    <img
                      src={
                        item.inSite ? this.apiserve.imageUrl + item.inSite :
                          item.link ? item.link :
                            '/images/image-placeholder.png'
                      }
                      alt="image"
                    />
                  </div>
                </div>
              ))}
          </Slider>
          <div>
            <div className="program_header d_flex">
                <h3>Shorts Included in film</h3>
            </div>
            <div className="program_inner">
                {
                    (this.state?.shortFilms.length > 0) && 
                    <ul>
                        {
                            this.state.shortFilms.map((item) => (
                                <li key={item._id}>
                                    <div className="d_flex list_inner d_flex_align_center">
                                        <div className="program_contents d_flex">
                                            <div className="program_image">
                                                <img 
                                                    src={item?.images?.inSite 
                                                            ? (this.apiserve.imageUrl + item.images.inSite) 
                                                            : item?.images?.link          
                                                                ? item.images.link
                                                                : '/images/image-placeholder.png'
                                                        }
                                                    alt='Short Film'
                                                />
                                            </div>
                                            <div className="program_contents_desc">
                                                <h2 className="program_title">{item?.title}</h2>
                                                <p className="program_time">{item?.runTime} min</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                }
            </div>
          </div>
          <div className="credit_section mt_15">
            <div className="credit_header">
              <h5>Credits</h5>
            </div>
            <div className="credit_content">
              <ul>
                <li className="d_flex">
                  {this.state.credits &&
                    this.state.credits.map((item) => (
                      <>
                      <label>{item && item.creditId && item.creditId.name}</label>
                      <span className="name">
                        {item.creditType &&
                          item.creditType.map((creditTypeName) => (
                            <p>{creditTypeName.creditsInsideType}</p>
                          ))}
                      </span>
                      </>
                    ))}
                </li>
              </ul>
            </div>
          </div>
          <div className="credit_section artist_section">
            <div className="credit_header">
              <h5>Meet The Artist</h5>
            </div>
            <div className="artist_content">
              {this.state.artist.map((item) => {
                return (
                  <>
                  <div className="d_flex inner_artist mb_15">

                    <div className="artist_user">
                      <img
                        src={

                          item.image
                            ? this.apiserve.imageUrl + item.image
                            : '/images/user.png'
                        }
                        alt="user"
                      />
                    </div>
                    <div className="artist_data">
                      <div className="d_flex user_name">
                        <h4>{item.name}</h4>
                        <div className="d_flex d_flex_align_center">
                          {item.twitter &&
                            <Link
                              className="d_flex d_flex_align_center"
                              onClick={() => this.handelTwitter(item)}
                            >
                              <TwitterIcon />
                            </Link>
                          }
                          {item.instagram &&
                            <Link
                              className="d_flex d_flex_align_center"
                              onClick={() => this.handelInstagram(item)}
                            >
                              <InstaIcon />
                            </Link>
                          }
                        </div>
                      </div>
                      <div className="user_desc">
                        <div className="editor_view" dangerouslySetInnerHTML={{ __html: item.description }} />
                      </div>
                      <div className="video_wrap">
                        <iframe src={getEmbedUrl(item.youtube)}></iframe>
                      </div>
                    </div>
                  </div>
                  </>
                )
              })}
            </div>
          </div>
        </div>
        <div className="tab_col feature_col" style={{maxWidth:`calc(100% - 460px)`}}>
          <div className="fpg_edits_links d_flex d_flex_align_center">
            <Link className="d_flex d_flex_align_center d_flex_justify_center"
              onClick={this.editFilmEvent}
            >
              <FpgeeditIcon />
              EDIT
              </Link>
            {this.state.status === 1 ?
              <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.disableFilm()}>
                <FpgDisableIcon /> DISABLE
                </Link>
              :
              <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.publishFilm()}>
                <FpgpublishIcon /> PUBLISH
                </Link>
            }
            {this.state.hideFromLive === true ?
              <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.hideFromLiveFilm()}>
                 <ViewIcon /> Show On Live
                </Link>
              :
              <Link className="d_flex d_flex_align_center d_flex_justify_center sd_show_hide_btn" onClick={() => this.showFromLiveFilm()}>
                 <ShowPassIcon /> Hide From Live
                </Link>
            }
            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.deleteFilm()}>
              <FpgDeleteIcon />
              DELETE
              </Link>
          </div>
          <div className="id_text mt_5 mb_10">
            <li className="d_flex">
              <label>Access: </label>
              <span>&nbsp;{this.state.access}</span>
            </li>

          </div>
          <p className="feature_text">{this.state.categoryname}</p>
          <div className="feature_title">
            <h3>{this.state.title}</h3>

            <div className="field_row mb_25">
              <label className="font_600"> Long Description</label>
              <div className="editor_view" dangerouslySetInnerHTML={{ __html: this.state.description }} />
            </div>
            <div className="field_row mb_25">
              <label className="font_600">Short Description</label>
              <div className="editor_view" dangerouslySetInnerHTML={{ __html: this.state.shortDescription }} />
            </div>
          </div>
          <div className="data_list">
            <ul>
              <li className="d_flex">
                <label>Short Introduction</label>
                <span>{this.state.shortIntroduction}</span>
              </li>
              <li className="d_flex">
                <label>Article</label>
                <span>{this.state.article}</span>
              </li>
              <li className="d_flex">
                <label>Year</label>
                <span>{this.state.year}</span>
              </li>
              <li className="d_flex">
                <label>Category</label>
                <span>{this.state.category ?.name}</span>
              </li>
              <li className="d_flex">
                <label>Country</label>
                <span>{this.state.country}</span>
              </li>
              <li className="d_flex">
                <label>Language</label>
                <span>{this.state.language}</span>
              </li>
              <li className="d_flex">
                <label>Run Time</label>
                <span>{this.state.runTime}</span>
              </li>
              <li className="d_flex">
                <label>Company</label>
                <span>{this.state.company}</span>
              </li>
              <li className="d_flex">
                <label>Website</label>
                <span>{this.state.website}</span>
              </li>
              <li className="d_flex">
                <label>Contact</label>
                <span>
                  {this.state.contact &&
                    this.state.contact.map((item) => <p>{item && item.emailPhone}</p>)}
                </span>
              </li>
            </ul>
            <ul>
              <li className="d_flex">
                <label>Genre</label>
                <span>
                  {this.state.genre &&
                    this.state.genre.map((item) => <p>{item.name}</p>)}
                </span>
              </li>
              <li className="d_flex">
                <label>Interest Tracks</label>
                <span>
                  {this.state.interestTrack &&
                    this.state.interestTrack.map((item) => (
                      <p>{item.name}</p>
                    ))}
                </span>
              </li>
              <li className="d_flex">
                <label>Accessibility</label>
                <span>
                  {this.state.accessibility &&
                    this.state.accessibility.map((item) => (
                      <p>{item.name}</p>
                    ))}
                </span>
              </li>
            </ul>
          </div>

          <div className="data_list">
            <ul>
              <li className="d_flex">
                <label>Award Category</label>
                <span>{this.state.awardCategory}</span>
              </li>
              <li className="d_flex">
                <label>Award Sponsor Logo</label>

                <span>
                  <img
                    src={
                      this.state.awardSponsorLogo ?
                        this.apiserve.imageUrl + this.state.awardSponsorLogo :
                        '/images/image-placeholder.png'
                    }
                    alt="image"
                  /></span>
              </li>
              <li className="d_flex">
                <label>Votes</label>
                <span>{this.state.votes}</span>
              </li>
              <li className="d_flex">
                <label>Explicit Content</label>
                <span>{this.state.isExplicitContent ? 'Yes' : 'No'}</span>
              </li>
              <li className="d_flex">
                <label>Explicit Content Disclaimer</label>
                <div className="right_editor"><div className="editor_view p_0" dangerouslySetInnerHTML={{ __html: this.state.explicitContent }} ></div></div>
              </li>
              <li className="d_flex">
                <label>Film Sponsor Logo</label>
                <span>
                  <img
                    src={
                      this.state.sponsorLogo ?
                        this.apiserve.imageUrl + this.state.sponsorLogo :
                        '/images/image-placeholder.png'
                    }
                    alt="image"
                  />
                </span>
              </li>
            </ul>
            <ul>
              <li className="d_flex">
                <label>Screening More info Title</label>
                <span>{this.state.screeningMoreInfoTitle}</span>
              </li>
              <li className="d_flex">
                <label>Screening - More Info</label>
                <div className="right_editor"><div className="editor_view p_0" dangerouslySetInnerHTML={{ __html: this.state.screeningMoreInfo }}></div></div>
              </li>

            </ul>
          </div>

          {this?.state?.category?.type !== 2 && <div className="screen_dates" style={{ maxWidth: "800px" }}>
            <table>
              <thead>
                <tr>
                  <th>Event Start Date & Time (MT) - Event End Date & Time (MT)</th>
                  <th>Screening Type</th>
                  <th>Location</th>
                  <th>Waitlist Slots</th>
                  <th>Accessibility</th>
                  <th>Interest Tracks</th>
                  <th>Supress Voting</th>
                </tr>
              </thead>
              <tbody>
              {this.state.category && (this.state.category._id === '5fa7d17c0329c105a039f9f7' || this.state.category.value === '5fa7d17c0329c105a039f9f7') ?
                  this.state.shortProgramme && this.state.shortProgramme.dateTime?.length >= 1 && this.state.shortProgramme.dateTime.map((item) => {
                    return (
                      item.locationType === "2" ?
                        <>
                        <tr className="disp_flex">
                          <td>{moment(item.date).tz("US/Mountain").format('MMM DD')}
                          <span className="time_text">
                            {moment(item.date).tz("US/Mountain").format('h:mm A')}
                          </span>
                          </td>
                            <td className="screening_type">
                            {this.getScreeningName(item) }
                          </td>
                          <td className="d_flex">

                            {
                              item ?.locationType === undefined || item.locationType === "2" ? <span className="d_block"> Online </span> :
                                item ?.locations.length > 0 ? item ?.locations && item.locations ?.map((loc) => {
                                  return <span className="d_block"> {loc ?.name} &nbsp;</span>
                                }) : ''
                                }

                          </td>
                          <td className="waitlist_slot">{(item.maxWaitListSlots === 0 && item?.locationType === "1") ? <span className="sd_zero_waitlist_slots">0 Waitlist Slots</span> : item.maxWaitListSlots}</td>
                          <td className="waitlist_slot">{item.accessibility.length > 0 ? item?.accessibility[0]?.name : '-'} {item?.accessibility.length > 1 && <>
                            <span>+ More</span>
                            <div className="tooltip_box">{item?.accessibility.map((acc, i) => {return (<span>{acc?.name}</span>)}) }</div>
                          </>}</td>
                          <td className="waitlist_slot">{renderInterestTracks(item.interestTrack)}</td>
                          <td className="waitlist_slot">{item.supressVoting ? 'Y' : 'N'}</td>
                        </tr>
                        </>
                        :
                          <>
                          <tr className="disp_flex">
                            <td>{moment(item.date).tz("US/Mountain").format('MMM DD')}
                            <span className="time_text">
                              {moment(item.date).tz("US/Mountain").format('h:mm A')}
                            </span>
                            </td>
                             <td className="screening_type">
                            {this.getScreeningName(item) }
                          </td>
                            <td className="d_flex">

                              {
                                item.locationType === "1" &&
                                  item ?.locations.length > 0 ? item ?.locations ?.map((loc) => {
                                    return <span className="d_block"> {loc ?.name} &nbsp;</span>
                                  }) : ''
                                    }

                            </td>
                            <td className="waitlist_slot">{(item.maxWaitListSlots === 0 && item?.locationType === "1") ? <span className="sd_zero_waitlist_slots">0 Waitlist Slots</span> : item.maxWaitListSlots}</td>
                            <td className="waitlist_slot">{item.accessibility.length > 0 ? item?.accessibility[0]?.name : '-'} {item?.accessibility.length > 1 && <>
                              <span>+ More</span>
                              <div className="tooltip_box">{item?.accessibility.map((acc, i) => {return (<span>{acc?.name}</span>)}) }</div>
                            </>}</td>
                            <td className="waitlist_slot">{renderInterestTracks(item.interestTrack)}</td>
                            <td className="waitlist_slot">{item.supressVoting ? 'Y' : 'N'}</td>
                          </tr>
                          </>

                    )
                  })
                  :
                  this.state.dateTime && this.state.dateTime.length >= 1 &&
                  this.state.dateTime &&
                  this.state.dateTime.map((item) => {
                    var fpgFlimViewStart = new Date(item.date);
                    var fpgFlimViewEnd = new Date(item.endDate);
                    console.log('this.state.dateTime view:::',this.state.dateTime)
                    return (
                      <>
                      {item.date !== undefined && 
                        <tr>
                            <td className="time_text time_text_nf">
                              {moment(fpgFlimViewStart).tz("US/Mountain").format('MMM DD')} {moment(fpgFlimViewStart).tz("US/Mountain").format('h:mm A')}  -  {moment(fpgFlimViewEnd).tz("US/Mountain").format('MMM DD')} {moment(fpgFlimViewEnd).tz("US/Mountain").format('h:mm A')}
                            </td>
                            <td className="screening_type">
                            {this.getScreeningName(item) }
                          </td>
                          <td>

                            {
                              item ?.locationType === undefined || item.locationType === "2" ? <span className="d_block"> Online </span> :
                                item ?.locations.length > 0 ? item ?.locations && item ?.locations ?.map((loc) => {
                                  return <span className="d_block"> {loc ?.name} &nbsp;</span>
                                }) : ''
                                  }

                          </td>
                          <td className="waitlist_slot">{(item.maxWaitListSlots === 0 && item?.locationType === "1") ? <span className="sd_zero_waitlist_slots">0 Waitlist Slots</span> : item.maxWaitListSlots}</td>
                          <td className="waitlist_slot">{item.accessibility.length > 0 ? item?.accessibility[0]?.name : '-'} {item?.accessibility.length > 1 && <>
                            <span>+ More</span>
                            <div className="tooltip_box">{item?.accessibility.map((acc, i) => {return (<span>{acc?.name}</span>)}) }</div>
                          </>}</td>
                          <td className="waitlist_slot">{renderInterestTracks(item.interestTrack)}</td>
                          <td className="waitlist_slot">{item.supressVoting ? 'Y' : 'N'}</td>
                        </tr>
                      }
                      </>
                    )
                  })
                }
              </tbody>
            </table>
          </div>}
          {this.state.qaReplayLink &&
            <div className="data_list">
              <ul>
                <li className="d_flex">
                  <label>QA Link</label>
                  <span>{this.state.qaReplayLink}</span>
                </li>
              </ul>
            </div>
          }
          <div className="connection_detail">
            <div className="paf_screening_info mt_25 w_100 border_btm_1 pb_25">
              <h2 className="paf_screening_info_title mb_10">Film Team - Public Contact Information</h2>
              <div className="mb_10">
                  <p className="paf_screening_info_subtitle uppercase mb_15">PUBLIC CONTACT (DURING FESTIVAL)</p>
                  <div className="data_list">
                      <ul className="mb_5">
                          <li className="d_flex">
                              <label>First Name</label>
                              <span>{this.state.publicContact?.firstName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Middle Name</label>
                              <span>{this.state.publicContact?.middleName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Last Name</label>
                              <span>{this.state.publicContact?.lastName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Company</label>
                              <span>{this.state.publicContact?.company}</span>
                          </li>
                          <li className="d_flex">
                              <label>Public Email</label>
                              <span>{this.state.publicContact?.publicEmail}</span>
                          </li>
                          <li className="d_flex">
                              <label>Website</label>
                              <span>{this.state.publicContact?.website}</span>
                          </li>
                          <li className="d_flex">
                              <label>Phone</label>
                              <span>{this.state.publicContact?.phoneNumber}</span>
                          </li>
                          <li className="d_flex">
                              <label>Phone Type</label>
                              <span>{this.state.publicContact?.type}</span>
                          </li>
                      </ul>
                  </div>
              </div>
              <div className="mb_10">
                  <p className="paf_screening_info_subtitle uppercase mb_15">POST FESTIVAL CONTACT (AFTER FESTIVAL)</p>
                  <div className="data_list">
                      <ul className="mb_5">
                          <li className="d_flex">
                              <label>First Name</label>
                              <span>{this.state.postFestivalContact?.firstName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Middle Name</label>
                              <span>{this.state.postFestivalContact?.middleName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Last Name</label>
                              <span>{this.state.postFestivalContact?.lastName}</span>
                          </li>
                          <li className="d_flex">
                              <label>Company</label>
                              <span>{this.state.postFestivalContact?.company}</span>
                          </li>
                          <li className="d_flex">
                              <label>Public Email</label>
                              <span>{this.state.postFestivalContact?.publicEmail}</span>
                          </li>
                          <li className="d_flex">
                              <label>Website</label>
                              <span>{this.state.postFestivalContact?.website}</span>
                          </li>
                          <li className="d_flex">
                              <label>Phone</label>
                              <span>{this.state.postFestivalContact?.phoneNumber}</span>
                          </li>
                          <li className="d_flex">
                              <label>Phone Type</label>
                              <span>{this.state.postFestivalContact?.type}</span>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
          </div>
        </div>
        </>
        {
          this.state.errorPopup ?
            <ErrorPopUp
              errorMsg={this.state.errorMsg}
              errorMsgPopup={this.errorMsgPopup}
            />
            : ''
        }
        {
          this.state.deleteFilm ?
            <PopUpCustomAll
              HeaderName='Delete?'
              insideDetails='You are about to delete an item and this action is permanent'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.deleteFilmPopupYes}
            />
            : ''
        }

        {
          this.state.publishFilm ?
            <PopUpCustomAll
              HeaderName='Publish Changes'
              insideDetails='Saving the current changes will publish it to the production site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.publishFilmPopupYes}
            />
            : ''
        }
        {
          this.state.showFromLiveFilm ?
            <PopUpCustomAll
              HeaderName='Hide From Live'
              insideDetails='Saving the current changes will hide it from the site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.hideFromLiveFilmPopupYes}
            />
            : ''
        }

        {
          this.state.disableFilm ?
            <PopUpCustomAll
              HeaderName='Disable?'
              insideDetails='You are about to disable an item, which will temporarily make it unavailable on the production site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.disableFilmPopupYes}
            />
            : ''
        }
        {
          this.state.hideFromLiveFilm ?
            <PopUpCustomAll
              HeaderName='Show On Live?'
              insideDetails='Saving the current changes will show it to the site'
              insideData='Do you want to proceed?'
              popupState={this.closeAdminUser}
              yesPopUp={this.showFromLiveFilmPopupYes}
            />
            : ''
        }
        {
          this.state.loaderFlag ? (
            <Loader />
          ) : (
              ""
            )
        }

      </div >
      </>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(FpgFilmDetailView)